interface WrapTagsProps {
  tags: string[];
  onTap: (tag: string) => void;
}

export function WrapTags({ tags, onTap }: WrapTagsProps) {
  if (tags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {tags?.map((tag) => (
        <button
          key={tag}
          onClick={() => onTap(tag)}
          className="rounded-full border border-black/15 dark:border-white/20 px-3 py-1 text-sm hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
        >
          {tag}
        </button>
      ))}
    </div>
  );
}
